var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('bid-set',_vm._b({attrs:{"click-tea":_vm.create_adgroup_b_and_o_optimize_deep_bid},on:{"handleBlur":function($event){return _vm.$emit('handleBlur')}}},'bid-set',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }